module.exports = __webpack_public_path__ + "static/apoyo02-ca063b7607c44e82917b2654bd9441a7.png";